import { defineComponent as o, createBlock as t, openBlock as l, resolveDynamicComponent as r, withCtx as a, renderSlot as n } from "vue";
const d = /* @__PURE__ */ o({
  __name: "SectionHeaderTag",
  props: {
    level: { default: 1 }
  },
  setup(s) {
    return (e, c) => (l(), t(r(`h${e.level}`), { class: "section-header-label" }, {
      default: a(() => [
        n(e.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
});
export {
  d as default
};
